module.exports = __webpack_public_path__ + "static/media/D0.c4441651.svg";